import { SCOPE_SECTION_ID } from 'modules/planning/components/PeriodWizard/steps/sections'

export const createScopeWizardStep = (translations: {
  scopeStepTitle: () => string
  scopeStepDescription: () => string
  next: () => string
  previous: () => string
}) => ({
  title: translations.scopeStepTitle(),
  description: translations.scopeStepDescription(),
  nextLabel: translations.next(),
  previousLabel: translations.previous(),
  sectionIds: [SCOPE_SECTION_ID],
})
